export * from './delete-besichtigung.service';
export * from './delete-besichtigung.service.module';